var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.592,
    height: 35.592,
    viewBox: "0 0 35.592 35.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(-317.794 -265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(317.794 265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M-10073.5-9157.562v13.1l5.9-5.841,5.808,3.059v-10.317Z",
    transform: "translate(10084.891 9168.64)",
    fill: "#37a0da"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M3.928.794a.614.614,0,0,0-.6.463L.812,11.263a.614.614,0,0,0-.01.095q-.005.027-.008.055V35.774a.614.614,0,0,0,.611.611H35.77a.614.614,0,0,0,.616-.611V11.433q0-.01,0-.02v0a.614.614,0,0,0-.017-.145L33.844,1.256A.614.614,0,0,0,33.25.794H3.928ZM4.4,2.022H14.479V10.8H2.194Zm11.3,0h5.767V10.8H15.706Zm6.995,0h10.07L34.986,10.8H22.7ZM2.021,12.029H14.479v9.4a.614.614,0,0,0,1.015.466l2.735-2.368,3.507,2.409a.614.614,0,0,0,.965-.507v-9.4H35.158V35.158H2.021Zm13.685,0h5.767v8.235l-2.936-2.021a.614.614,0,0,0-.751.041l-2.079,1.8Z",
    transform: "translate(-0.794 -0.794)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct1);
export default __webpack_public_path__ + "static/media/product1.a7681dc1d5a4c10c8867774fe5657783.svg";
export { ForwardRef as ReactComponent };